module.exports = __webpack_public_path__ + "static/media/navy-check.5aef2df6.svg";